import { Injectable } from '@angular/core';

import { Action, Actions, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpApiService } from '../../../core/http-api.service';
import { EntityStateHelpers, EntityUpdateStrategy, IEntityState } from '../../../core/state';
import { EntityState } from '../../../core/state/entity-state';
import { LoadReferralsProfile, UpdateReferralsProfile } from './profile.actions';
import { ReferralsPortalProfile } from './profile.interfaces';

export type IProfileRepo = IEntityState<ReferralsPortalProfile>;

@State<IProfileRepo>({
  name: 'profile',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsPortalProfileRepo extends EntityState<ReferralsPortalProfile>() {
  constructor(private actions$: Actions, private httpApi: HttpApiService) {
    super(actions$, EntityUpdateStrategy.update);
  }

  @Action(LoadReferralsProfile)
  public loadReferralsProfile(
    ctx: StateContext<IProfileRepo>,
    action: LoadReferralsProfile,
  ): Observable<any> {
    this.markAsLoading(ctx, action);
    return this.httpApi.get('/profile').pipe(
      tap(res => {
        this.save(ctx, action, res.referrer);

        if (action.payload && action.payload.active) {
          this.markAsActive(ctx, res.referrer.id);
        }
      }),
    );
  }

  @Action(UpdateReferralsProfile)
  public updateProfile(
    ctx: StateContext<IProfileRepo>,
    action: UpdateReferralsProfile,
  ): Observable<any> {
    this.markAsLoading(ctx, action);
    return this.httpApi
      .patch('/profile', undefined, { profile: action.payload })
      .pipe(tap(res => this.save(ctx, action, res.referrer)));
  }
}
